// 在画布上画一个雷达图
// 参考地址
// https://juejin.im/entry/5981375d6fb9a03c3f404c91

// 默认画布的尺寸
let mW = 240
let mH = 206
let centerX = 422
let centerY = 500
let mRadius = Math.min(mW, mH) - 100 // 半径(减去的值用于给绘制的文本留空间)

let mData = [
  // ['速度', 77],
  // ['力量', 72],
  // ['防守', 46],
  ['射门', 50],
  ['传球', 80],
  ['耐力', 60]
]
let mCount = mData.length // 边数
let mAngle = Math.PI * 2 / mCount // 角度
let mAngleAdd = mCount === 3 ? Math.PI / 6 : 0 // 角度补偿

// 样式设置
// 线，粗细，颜色，样式
const mLineColor = '#B8B8B8'
const mLineWidth = 1
// 文字，大小，颜色，字体
let mFontSize = 22 // 文本的字体大小
let mFontColor = '#000000'
let mFontFamily = 'Microsoft Yahei'
// 点，大小，颜色
let mPointSize = 4 // 点的大小
let mPointStyle = 'rgba(255, 0, 0, 0.8)'
// 阴影面积，颜色，透明度
let mRegionStyle = 'rgba(255, 0, 0, 0.5)'
let mColorLines = '#B8B8B8' // 顶点连线颜色

// 绘制多边形边
function drawPolygon (ctx) {
  ctx.save()

  ctx.strokeStyle = mLineColor
  ctx.lineWidth = mLineWidth
  let r = mRadius / mCount // 单位半径
  // 画6个圈
  for (let i = 0; i < mCount; i++) {
    ctx.beginPath()
    const currR = r * (i + 1) // 当前半径
    // 画6条边
    for (let j = 0; j < mCount; j++) {
      const x = centerX + currR * Math.cos(mAngle * j + mAngleAdd)
      const y = centerY + currR * Math.sin(mAngle * j + mAngleAdd)

      ctx.lineTo(x, y)
    }
    ctx.closePath()
    ctx.stroke()
  }

  ctx.restore()
}

// 顶点连线
function drawLines (ctx) {
  ctx.save()

  ctx.beginPath()
  ctx.strokeStyle = mColorLines

  for (let i = 0; i < mCount; i++) {
    const x = centerX + mRadius * Math.cos(mAngle * i + mAngleAdd)
    const y = centerY + mRadius * Math.sin(mAngle * i + mAngleAdd)

    ctx.moveTo(centerX, centerY)
    ctx.lineTo(x, y)
  }

  ctx.stroke()
  ctx.restore()
}

// 绘制文本
function drawText (ctx) {
  ctx.save()

  const fontSize = mFontSize
  ctx.font = 'bolder ' + fontSize + 'px Arial'
  ctx.fillStyle = '#88aae4'

  for (let i = 0; i < mCount; i++) {
    const x = centerX + mRadius * Math.cos(mAngle * i + mAngleAdd)
    const y = centerY + mRadius * Math.sin(mAngle * i + mAngleAdd)

    if (mAngle * i >= 0 && mAngle * i <= Math.PI / 2) {
      // 右边
      let rightMove = ctx.measureText(mData[i][0]).width / 2;
      if(rightMove > 60) rightMove = rightMove * 1.3
      
      ctx.fillText(mData[i][0], centerX + 110 - rightMove, y + 1.8 * fontSize)
    } else if (mAngle * i > Math.PI / 2 && mAngle * i <= Math.PI) {
      // 左边
      let leftMove = ctx.measureText(mData[i][0]).width / 2;
      if(leftMove > 50) leftMove = 45
      
      ctx.fillText(mData[i][0], centerX - 110 - leftMove, y + 1.8 * fontSize)
    } else if (mAngle * i > Math.PI && mAngle * i <= Math.PI * 3 / 2) {
      // 中间
      ctx.fillText(mData[i][0], centerX - ctx.measureText(mData[i][0]).width / 2, y - fontSize - 10)
    } else {
      // console.log(3)
      ctx.fillText(mData[i][0], x, y)
    }
  }

  ctx.restore()
}

// 绘制数据区域
function drawRegion (ctx) {
  ctx.save()

  ctx.beginPath()
  for (let i = 0; i < mCount; i++) {
    const x = centerX + mRadius * Math.cos(mAngle * i + mAngleAdd) * mData[i][1] / 100
    const y = centerY + mRadius * Math.sin(mAngle * i + mAngleAdd) * mData[i][1] / 100

    ctx.lineTo(x, y)
  }
  ctx.closePath()
  ctx.lineWidth = 3
  ctx.strokeStyle = '#ffffcc'
  ctx.stroke()

  // ctx.fillStyle = mRegionStyle
  ctx.fillStyle = 'rgba(250, 60, 60,  0.4)'
  ctx.fill()

  ctx.restore()
}

// 画点
function drawCircle (ctx) {
  ctx.save()

  const r = mPointSize
  for (let i = 0; i < mCount; i++) {
    const x = centerX + mRadius * Math.cos(mAngle * i + mAngleAdd) * mData[i][1] / 100
    const y = centerY + mRadius * Math.sin(mAngle * i + mAngleAdd) * mData[i][1] / 100

    ctx.beginPath()
    ctx.arc(x, y, r, 0, Math.PI * 2)
    ctx.fillStyle = mPointStyle
    ctx.fill()
  }

  ctx.restore()
}

// 初始化
function init (canvas, data, option) {

  const ctx = canvas.getContext('2d')
  // mW = canvas.width
  // mH = canvas.height
  // centerX = mW / 2
  // centerY = mH / 2 + 20
  // mRadius = Math.min(mW, mH) - 80 // 半径(减去的值用于给绘制的文本留空间)
  mW = 240
  mH = 206
  if (option.isMyPage) {
    centerX = 426
    centerY = 330
  } else {
    centerX = 415
    centerY = 347
  }
  mRadius = Math.min(mW, mH) - 100 // 半径(减去的值用于给绘制的文本留空间)

  // 获取数据
  mData = data
  mCount = mData.length // 边数
  mAngle = Math.PI * 2 / mCount // 角度
  mAngleAdd = mCount === 3 ? Math.PI / 6 : 0 // 角度补偿

  // drawPolygon(ctx)
  // drawLines(ctx)
  drawText(ctx)
  drawRegion(ctx)
  // drawCircle(ctx)
}

export default init
